import { auth } from './supabase'

/**
 * Support Bundle Utility [FE.8.1]
 * Creates a PHI-safe diagnostic bundle for support.
 */
export async function generateSupportBundle() {
    const session = await auth.getSession()

    const bundle = {
        timestamp: new Date().toISOString(),
        environment: import.meta.env.MODE,
        version: '0.1.0-alpha',
        session_info: {
            has_session: Boolean(session.data.session),
            role: session.data.session?.user?.role ?? 'unknown',
        },
        // Trace ID history could be added here if stored in a local log
        logs: [
            { event: 'app_start', timestamp: new Date().toISOString() }
        ]
    }

    return JSON.stringify(bundle, null, 2)
}

export async function copySupportBundleToClipboard() {
    const bundle = await generateSupportBundle()
    await navigator.clipboard.writeText(bundle)
    return bundle
}
